import allApi from './api'
import store from "./store";
let timers = {
    countDown: null
}

let data = {
    countDownTime: 0,
    audioData:{
        chapterList: [],
        prevNum: -1,
        nextNum: -1,
        pageNum: -1,
        pages: -1,
        chapterId: -1,
        rank: 1,
        audioType: 'mini',
        playbackRate: 1,
    }
}
let fn = {
    // 音频播放当前时间与总时长转换  秒转换成00:00
    setAudioTime:(time) => {
        var minute = parseInt(time / 60);
        if (minute < 10) {
            minute = "0" + minute;
        }
        var second = parseInt(time % 60);
        if (second < 10) {
            second = "0" + second;
        }
        return minute + ":" + second;
    },
    // 章节创建日期格式转换成年月日
    setCreatTime:(time) => {
        var data = new Date(time);
        var year = data.getFullYear(),
        mon = data.getMonth()+1,
        sec = data.getSeconds();
        if( mon < 10 ) {
            mon = "0" + mon;
        }
        if( sec < 10 ) {
            sec = "0" + sec;
        }
        return year + "-" + mon + "-" + sec;
    },
    // 去除前后空格
    trim: (str)=>{ 
        return str.replace(/(^\s*)|(\s*$)/g, ""); 
    },
    addHistory() {
        // var that = this;
        if( localStorage.getItem("status") == 'false' || !localStorage.getItem("status") ) {
            if( store.state.addHistoryTimer ) store.commit("clearAddHistory");
            return false;
        }

        var param = {
            bookId: store.state.bookId,
            chapterId: store.state.actChapter.chapterid,
            duration: store.state.audioInfo.currentTime,
            chapterRank: store.state.actChapter.rank,
            ticket: localStorage.getItem("ticket")
        }
        allApi.addUserBookHistory(param).then((resource)=>{
            // console.log(resource.data);
            if( resource.data.data == 1 ) {
                console.log("历史记录添加成功");
            }
            
        })
    },
}

let commins = {
    timers,
    data,
    fn
}

export default commins;
